import moment from "moment-timezone";
import { isEmpty } from "lodash";
import { ZoomManager } from "../../services/zoomManager";
import { Apollo, State2Way } from "@/decorators";
import { User } from "../../store/store";

import UPDATE_DOCUMENT_EDIT from "../../graphql/document/UpdateDocumentEdit.gql";
import RESTORE_DOCUMENT from "../../graphql/document/RestoreDocument.gql";
import DELETE_DOCUMENT_QUERY from "../../graphql/document/DeleteDocument.gql";
import ANALYSE_DOCUMENT from "../../graphql/document/AnalyseDocument.gql";
import UPDATE_DOCUMENT_CHAT from "../../graphql/document/UpdateDocumentChat.gql";
import DOCUMENTS_PREV_NEXT_QUERY from "../../graphql/document/PrevNextDocument.gql";
// import DOCUMENT_ONLINE_USER_SUBSCRIPTION from '../../graphql/document/DocumentOnlineUserSubscription.gql'
// import CREATE_ONLINE_USER_ACTIVITY from '../../graphql/CreateOnlineUserActivity.gql'
// import DELETE_ONLINE_USER_ACTIVITY from '../../graphql/DeleteOnlineUserActivity.gql'
import UPDATE_DOCUMENT_ACCOUNTABLE_ACCOUNT from "../../graphql/document/UpdateDocumentAccountableAccount.gql";
import COMPUTE_SUGGESTIONS_FROM_RECONCILIATON from "../../graphql/ComputeSuggestionsFromReconciliation.gql";
import UPDATE_DOCUMENT_DATA from "../../graphql/document/UpdateDocumentData.gql";
import UPDATE_DOCUMENT_DUEDATE from "../../graphql/document/UpdateDocumentDueDate.gql";
import DELETE_AUDIT_CHECK_RESULT_AND_RESULTS from "../../graphql/audit/DeleteAuditCheckResultId.gql";
import UPDATE_DOCUMENT_AUDIT_CHECK_RESULTS from "../../graphql/document/UpdateDocumentAuditCheckResults.gql";

import { UserActivity } from "../../services/userActivityServices";
import {
    getReconciliationStatus,
    getReconciliationCallToAction,
    isDeletionDisabled,
} from "../../services/documentServices";
import { getUserDisplayName } from "../../services/userServices";

import getEnv from "../../env";
import {
    getAccountingDate,
    getLastAccountingClosingFromStore,
    isInsideAccountingClosing,
} from "../../services/accountingPeriods";
import { formatOrderBy, getCommonDocumentWhere } from "../../services/graphqlServices";
import { ComponentBase } from "../ComponentBase";
import { getDBFormattedDate } from "@/services/dateServices";
import axios from "axios";
import { Component } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { getConnectAccountableAccount } from "@/services/accountableAccountServices";

const env = getEnv();

@Component({
    emits: [
        "updating",
        "back",
        "edit",
        "deleted",
        "next",
        "previous",
        "openReconciliation",
        "task-ended",
        "deleted-acr",
    ],
})
export class DocumentBase extends ComponentBase {
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: null }) inDocument: any;

    @Prop({ default: "Router" }) mode: string;

    @Prop({ default: false }) nextIdIsset: boolean;

    @Prop({ default: false }) previousIdIsset: boolean;
    @Prop({ default: false }) isAccountingItem: boolean;

    /**
     * If true, the icon for back will be displayed (default)
     * If false, the icon for back is not displayed without the mode type
     * @type {boolean}
     * @memberof DocumentBase
     */
    @Prop({ default: true }) goBackHistory: boolean;

    analyseDocumentDialog = false;

    document: any = {
        workingCopy: {
            id: "",
            type: "PNG",
            key: "",
            height: 0,
            width: 0,
        },
        original: {
            id: "",
            type: "PDF",
            key: "",
            height: 0,
            width: 0,
        },
        owner: {
            id: "",
            firstname: "",
            lastname: "",
            company: null,
            profile: {
                id: "",
            },
        },
        accountableAccount: null,
        accountableAccountAuto: null,
        analysis: {},
        id: "",
        name: "",
        creditNote: false,
        vatType: null,
        multiVat: false,
        thirdPartyCompany: {
            id: null,
        },
        thirdPartyAccountableAccount: null,
        company: null,
        tags: null,
        type: null,
        signedUrl: "",
        signedUrlOCR: "",
        signedUrlAnalysis: "",
        invoiceNumber: "",
        // onlineUsers: null,
        chat: null,
        show: true,
        useForReconciliation: true,
        vatDeclaration: null,
        expenseReport: null,
        invoice: null,
        accountingItemImport: null,
        status: null,
        accountingLines: null,
        reconciliationStatus: {},
        accountingLinesLocked: false,
        auditCheckResults: null,
        accountingClosing: null,
    };

    rootOrigin = false;
    /**
     * Used for rotation of ossPdf
     */
    documentPdfRotation: number = 0;

    activity: UserActivity;

    displayActivity = false;

    updating = false;

    @Watch("updating")
    onUpdatingChanged() {
        this.$emit("updating", this.updating);
    }

    get accountingLinesLocked() {
        return this.inDocument?.accountingLinesLocked;
    }

    canBeRestoredTooltipMessages: Array<string> = [];

    get showRestoreDocumentBtn() {
        this.canBeRestoredTooltipMessages.length = 0;
        if (this.inDocument.status === "DELETED") {
            if (!this.currentUser.profile.configuration.document.write) {
                this.canBeRestoredTooltipMessages.push("Vous êtes en mode lecture seule");
            }
            if (this.documentIsInAccountingClosing) {
                this.canBeRestoredTooltipMessages.push(
                    "Document vérrouillé par une période comptable clôturée ou par une situation",
                );
            }
            return true;
        }
        return false;
    }

    get accountingPeriods() {
        return this.$store.state.accountingPeriod.accountingPeriods;
    }

    get documentAccountingPeriod() {
        if (!this.document) {
            return undefined;
        }
        if (this.accountingPeriods) {
            const docDateYYYYMMDD = moment(this.document.date).format("YYYY-MM-DD");
            const documentAccountingPeriod = this.accountingPeriods.find(
                (ap) =>
                    moment(ap.start).startOf("day").format("YYYY-MM-DD") <= docDateYYYYMMDD &&
                    moment(ap.end).endOf("day").format("YYYY-MM-DD") >= docDateYYYYMMDD,
            );
            if (documentAccountingPeriod) {
                return documentAccountingPeriod;
            }
        }
        return undefined;
    }

    updatePrevNext() {
        let initPrevNext = true;
        if (this.inDocument) {
            if (this.prevNext && this.prevNext?.currentId === this.inDocument.id) {
                // this.previousDocumentId = this.prevNext.prevId
                // this.nextDocumentId = this.prevNext.nextId
                initPrevNext = false;
            }
        }
        if (initPrevNext) {
            this.prevNext = {
                currentId: "",
                prevId: "",
                nextId: "",
            };
        }
    }

    async onDocumentChangedCommon(prev, next) {
        if (prev !== next) {
            this.document = this.inDocument;
            await this.getAnalysis();
            this.clearVariantList();
            if (this.document.signedUrl && !this.isPDF) {
                this.zoomManager.instanciateSvgZoom(this.svgSuffix);
            }
        }
    }

    finishMounted() {
        // this.companyTags = new CompanyTags(this.companyId, this.activateTagguing)
        this.updatePrevNext();
        this.initializeUserActivity();
        if (
            this.filter?.status !== "RECONCILIATION_MISSING" &&
            this.filter?.status !== "RECONCILIATION_DONE"
        ) {
            this.prevNextSmartQuery();
        }
        console.log("DocumentBase mounted", this.goBackHistory);
    }

    /**
     * Rotates the page in the PDF component.
     * @param direction The direction to rotate the component.
     * @param zoomManager The zoomManager instance given.
     * @param documentPdfRotation The local rotation of the document.
     */
    rotate(direction: "right" | "left", zoomManager: ZoomManager, documentPdfRotation: number) {
        if (!this.isPDF) {
            switch (direction) {
                case "right":
                    zoomManager.rotateSvg((documentPdfRotation + 90) % 360);
                    break;
                case "left":
                    zoomManager.rotateSvg((documentPdfRotation - 90) % 360);
                    break;
            }
        } else {
            return (documentPdfRotation + (direction === "right" ? 90 : -90)) % 360;
        }
        return 0;
    }

    @State2Way("updateFilter", "documentFilter")
    filter!: {
        status: string;
        pagination: {
            page?: number;
            rowsPerPage?: number;
            totalItems?: number;
            sortBy?: string;
            descending: string;
        };
    };

    @Apollo({
        query: DOCUMENTS_PREV_NEXT_QUERY,
        variables() {
            return this.getWhere();
        },
        specificResult({ data }) {
            if (data) {
                this.prevNextResult = data;
                const nextDocumentId =
                    data.nextDocumentId && data.nextDocumentId.length > 0
                        ? data.nextDocumentId[0].id
                        : "";
                const previousDocumentId =
                    data.previousDocumentId && data.previousDocumentId.length > 0
                        ? data.previousDocumentId[0].id
                        : "";

                this.prevNext = {
                    currentId: this.documentId,
                    prevId: previousDocumentId,
                    nextId: nextDocumentId,
                };
            } else {
                this.prevNext = {
                    currentId: this.documentId,
                    prevId: "",
                    nextId: "",
                };
            }
        },
        skip() {
            return (
                this.mode !== "Router" ||
                this.rootOrigin ||
                !this.documentId ||
                (this.prevNext && this.prevNext.currentId === this.documentId) ||
                !this.selectedCompany.id
            );
        },
    })
    prevNextResult = null;

    @State2Way("updateDocumentPrevNext", "documentFilter.prevNext")
    prevNext!: { currentId: string; prevId: string; nextId: string };

    @State2Way("updateShowFilterBox", (state) => state.documentFilter.showFilterBox)
    showFilterBox!: boolean;

    @State2Way("updatePagination", "documentFilter.pagination")
    pagination!: {
        page?: number;
        rowsPerPage?: number;
        totalItems?: number;
        sortBy?: string;
        descending: string;
    };

    @State2Way("updateToBeDoneStatus", "toBeDoneStatus")
    toBeDoneStatus!: boolean;

    back() {
        if (this.toBeDoneStatus) {
            this.toBeDoneStatus = false;
            this.$router.back();
        } else if (this.mode === "ExpenseReport") {
            this.$emit("back");
        } else {
            this.$router.go(-1);
        }
    }

    get selectedAccountingClosing() {
        return this.$store.state.accountingPeriod.selectedAccountingClosing?.id
            ? this.$store.state.accountingPeriod.selectedAccountingClosing
            : null;
    }

    getUsers() {
        return [];
    }

    //
    // user
    //
    get currentUser(): User {
        return this.$store.state.user;
    }

    get activateTagguing() {
        return this.currentUser.profile?.configuration.tag.write;
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get isAutonomousUser() {
        return this.currentUser?.isAutonomousUser;
    }

    get documentIsInAccountingClosing() {
        if (this.document) {
            return isInsideAccountingClosing(this.$store, this.document.date);
        }
        return false;
    }

    get isIncomingOutgoingPayment() {
        if (
            this.selectedCompany.profile &&
            this.selectedCompany.profile.accountingType === "INCOMING_OUTGOING_PAYMENT"
        ) {
            return true;
        }
        return false;
    }

    getUserDisplayName(user) {
        return getUserDisplayName(user);
    }

    currentAccountUser: any = {
        id: "",
        firstname: "",
        lastname: "",
        company: null,
        profile: {
            id: "",
            name: "",
        },
    };

    defaultUser: any = {
        id: "",
        firstname: "",
        lastname: "",
        company: null,
        profile: {
            id: "",
            name: "",
        },
    };

    get declareSalesInvoices() {
        // if (this.selectedCompany.taxSystem === "BNC" &&
        //     this.selectedCompany.vatSystem === "NotSubjectTo") return false;
        return true;
    }

    get legalForm() {
        return this.selectedCompany.legalForm;
    }

    thirdPartyType() {
        if (this.document) {
            if (
                this.document.type === "SALES_INVOICE" ||
                this.document.type === "SALES_INVOICE_AUTO"
            ) {
                return "Client ";
            }
            if (
                this.document.type === "PURCHASE_INVOICE" ||
                this.document.type === "CURRENT_ACCOUNT" ||
                this.document.type === "OPERATOR_ACCOUNT" ||
                this.document.type === "EXPENSE_REPORT" ||
                this.document.type === "EXPENSE_REPORT_DOCUMENT" ||
                this.document.type === "WITHOUT_INVOICE"
            ) {
                return "Fournisseur ";
            }
            if (this.document.type === "ZTILL_RECEIPT") {
                return "Z de caisse";
            }
        }
        return "";
    }

    updateCurrentAccountUser() {
        const currentAccountUsers = this.getUsers();
        if (currentAccountUsers.length) {
            if (this.inDocument.owner) {
                const foundUser = currentAccountUsers.find(
                    (u) => u.id === this.inDocument.owner.id,
                );
                if (foundUser) {
                    this.currentAccountUser = foundUser;
                } else {
                    this.currentAccountUser = currentAccountUsers[0];
                }
            } else {
                this.currentAccountUser = currentAccountUsers[0];
            }
        } else {
            this.currentAccountUser = this.defaultUser;
        }
    }

    get checkCurrentAccountUser() {
        return !!this.currentAccountUser && !!this.currentAccountUser.id;
    }

    get currentAccountUserRules() {
        return [
            (u) => {
                if (!this.checkCurrentAccountUser) {
                    return "Collaborateur requis";
                }
                return true;
            },
        ];
    }

    //
    // Company
    //

    get selectedCompany() {
        return this.$store.getters.getCompany(this.companyId);
    }

    get enableStock() {
        return this.selectedCompany?.profile?.stock;
    }

    get documentId() {
        if (this.inDocument) return this.inDocument.id;
        if (this.$route.params.id) return this.$route.params.id;
        return "";
    }

    get netAmountSigned() {
        return this.document.netAmountSigned;
    }

    formatCategory(type: string) {
        if (!type) {
            return "XXX";
        }
        if (this.document.creditNote && (type === "PURCHASE_INVOICE" || type === "SALES_INVOICE")) {
            this.$t("document.type." + type + "_CREDITNOTE");
        }
        return this.$t("document.type." + type);
    }

    //
    // date
    //

    get dateRules() {
        return [
            (v) => (v ? true : "Date requise"),
            (v) => this.form.date.validated || "Date invalide",
            (v) => this.verifDate(v) || "Date invalide",
        ];
    }

    formatObjectDate(date) {
        if (!date || !date.value) return "";
        return this.formatDate(date.value);
    }

    verifDate(date) {
        return moment(date, "DD/MM/YYYY").isValid();
    }

    formatDate(date, format = "DD/MM/YYYY") {
        if (!date) return "";
        if (date.match(/[0-9]{4}\-[0-1][0-9]\-[0-3][0-9]/)) {
            const mDate = moment(date);
            if (!mDate.isValid()) return date;
            return mDate.format(format);
        }
        return date;
    }

    onDateChange(meta: any, type: string, selectedValue: any) {
        if (!selectedValue) {
            return;
        }
        if (typeof selectedValue === "string") {
            meta.value = selectedValue;
        } else if (selectedValue.currentTarget) {
            meta.value = selectedValue.currentTarget.value;
        } else {
            return;
        }
        if (type === "date") {
            // const date = moment(meta.value, ['DD/MM/YY', 'DD-MM-YY', 'DD/MM/YYYY', 'DD-MM-YYYY', 'DDMMYYYY']);
            if (meta.value.match(/[0-3][0-9]\/[0-1][0-9]\/[0-9]{4}/)) {
                const date = moment(meta.value, "DD/MM/YYYY");
                if (date && date.isValid()) {
                    meta.value = date.format("YYYY-MM-DD");
                }
                meta.validated = this.validateDateField(meta, "date");
            } else {
                meta.validated = false;
            }
        } else {
            meta.validated = true;
        }
    }

    //
    //
    //

    async editDocument() {
        if (this.document && this.document.id) {
            await this.$apollo.mutate({
                mutation: UPDATE_DOCUMENT_EDIT,
                variables: {
                    id: this.document.id,
                    status: "ANALYSED",
                },
            });
            try {
                await this.createUserActivity(this.document.id, "UPDATE");
            } catch (e) {
                console.error(e);
            }
        }
        this.$emit("edit", {
            documentId: this.documentId,
        });
    }

    restoreLoading: boolean = false;
    async restoreDocument() {
        this.restoreLoading = true;
        if (this.document && this.document.id) {
            await this.$apollo.mutate({
                mutation: RESTORE_DOCUMENT,
                variables: {
                    id: this.document.id,
                    status: this.document.accountingLinesLocked ? "VALIDATED" : "ANALYSED",
                },
            });
            // try {
            //     await this.createUserActivity(this.document.id, "RESTORE")
            // } catch(e) {
            //     console.error(e)
            // }
        }
        this.restoreLoading = false;
        this.$emit("edit", {
            documentId: this.documentId,
        });
    }

    get file() {
        return this.document ? this.document.workingCopy || this.document.original : null;
    }

    get isImage() {
        const imageTypes = ["JPEG", "JPG", "PNG", "TIFF", "TIF"];
        return this.file && imageTypes.indexOf(this.file.type) !== -1;
    }

    get isPDF() {
        // debugger;
        return this.file && this.file.type === "PDF";
    }

    get isCSV() {
        return (
            this.file &&
            (this.file.type === "CSV" ||
                this.file.type === "TSV" ||
                this.file.type === "TXT" ||
                this.file.type === "DAT")
        );
    }

    get imageWidth() {
        return this.file ? this.file.width || 20.0 : 20.0;
    }

    get imageHeight() {
        return this.file ? this.file.height || 20.0 : 20.0;
    }

    get fullAddress() {
        let address = "";
        if (!this.document || !this.document.thirdPartyCompany) {
            return address;
        }
        if (this.document.thirdPartyCompany.address) {
            address += this.document.thirdPartyCompany.address;
        }
        if (this.document.thirdPartyCompany.postalCode) {
            if (address) address += " ";
            address += this.document.thirdPartyCompany.postalCode;
        }
        return address;
    }

    //
    // register unregister user
    //

    onlineUserActivity = {
        id: "",
        userId: "",
        documentId: "",
    };

    initializeUserActivity() {
        this.activity = new UserActivity("CREATE", "DOCUMENT", moment());
    }

    async createUserActivity(documentId, action) {
        // try {
        //     await this.activity.create(this.$apollo, this.currentUser.id, this.companyId, documentId, action)
        //     this.initializeUserActivity()
        // } catch(e) {
        //     console.error(e)
        // }
    }

    accountingLinesRefreshKey = 0;

    async onAccountingItemUpdated() {
        this.accountingLinesRefreshKey++;
        await this.onUpdated();
    }

    async onUpdated() {
        // await this.createUserActivity(this.document.id, "UPDATE")
        this.$emit("edit", {
            documentId: this.documentId,
        });
        this.startToBeDoneIfNecessary();
    }

    //
    // mounted
    //

    getWhere() {
        const where = getCommonDocumentWhere(
            this.selectedCompany.id,
            this.selectedAccountingClosing,
            this.filter,
            false,
        );
        return {
            companyId: this.selectedCompany.id,
            where,
            documentId: this.documentId,
            orderBy: formatOrderBy(this.filter.pagination, "type"),
        };
    }

    prevNextSmartQuery() {
        this.$apollo.queries.prevNextResult.refetch();
    }

    //
    // download document
    //
    dialogChooseDownload = false;

    startDownloadFile() {
        // before : confirmation dialog to select the type of download
        // this.dialogChooseDownload = true
        // now : direct download
        this.downloadFile(true, false);
    }

    downloadFile(original, workingCopy: boolean = false) {
        // debugger;
        const randNumber = Math.floor(Math.random() * 99);
        if (original) {
            if (!workingCopy) {
                window.open(
                    `${env.VUE_APP_BACKEND}/document/download/${this.inDocument.id}/original?cache=${randNumber}`,
                    "_blank",
                );
            } else {
                window.open(
                    `${env.VUE_APP_BACKEND}/document/download/${this.inDocument.id}/workingCopy?cache=${randNumber}`,
                    "_blank",
                );
            }
        } else {
            window.open(
                `${env.VUE_APP_BACKEND}/document/download/${this.inDocument.id}?cache=${randNumber}`,
                "_blank",
            );
        }
        this.dialogChooseDownload = false;
    }

    //
    // restart analysis
    //
    get restartAnalysis() {
        // debugger
        if (!this.isAccountingUser) return false;
        if (!this.inDocument) return false;
        if (this.inDocument.accountingLinesLocked) return false;
        if (this.currentUser.profile.configuration.document.write) {
            if (
                this.inDocument.status.startsWith("ANALYSED") ||
                this.inDocument.status === "UPLOADED" ||
                this.inDocument.status === "ORIGINAL_UPLOADED"
            ) {
                return true;
            }
        }
        if (this.buidIsNeccessary) {
            return true;
        }
        return false;
    }

    get buidIsNeccessary() {
        if (!this.document) return false;
        if (this.document.accountingLines && this.document.accountingLines.length) {
            let totalAmount = 0.0;
            for (const al of this.document.accountingLines) {
                if (al.type !== "MANAGEMENT") {
                    totalAmount += al.amountSigned;
                }
            }
            if (Math.abs(totalAmount) > 1e-2) {
                return true;
            }
            return false;
        }
        return false;
    }

    get linkedBankTransactions() {
        const linkedBankTransactions = [];
        if (!this.inDocument) return linkedBankTransactions;
        if (this.inDocument?.accountingLines?.length) {
            for (const al of this.inDocument.accountingLines) {
                if (
                    al.bankTransaction?.id &&
                    !linkedBankTransactions.find((bt) => bt.id === al.bankTransaction.id)
                ) {
                    linkedBankTransactions.push(al.bankTransaction);
                }
            }
        }
        return linkedBankTransactions;
    }

    get isBankTransactionReceipt() {
        return this.linkedBankTransactions.length > 0;
    }

    get isExpenseReportDocument() {
        return this.inDocument?.type === "EXPENSE_REPORT_DOCUMENT";
    }

    async analyseDocument() {
        if (!this.restartAnalysis) {
            this.analyseDocumentDialog = false;
            return;
        }
        await this.$apollo.mutate({
            mutation: ANALYSE_DOCUMENT,
            variables: {
                id: this.inDocument.id,
            },
        });
        // await this.createUserActivity(this.document.id, "UPDATE")

        this.analyseDocumentDialog = false;
    }

    //
    //
    //

    get disabledAccountingEdition() {
        if (!this.inDocument) return true;
        if (this.documentIsInAccountingClosing) return true;
        // if (this.inDocument.accountingItemImport) return true;

        if (this.inDocument.status === "DENIED" || this.inDocument.status === "DELETED")
            return true;

        if (this.inDocument.isResultOf?.id) return true;

        if (this.inDocument.invoice) return false;

        if (this.inDocument.accountingLinesLocked) {
            return !!this.inDocument.vatDeclaration;
        }
        return true;
    }

    //
    // delete document
    //

    get inDocumentIsResultOfAcr() {
        if (!this.inDocument) return null;
        return this.inDocument?.isResultOf?.auditCheck?.key;
    }

    get firstAcrResultDate_InAccountingClosing() {
        if (!this.inDocument) return null;

        if (this.inDocument?.isResultOf?.results?.length) {
            const lastAccountingClosingDate = getLastAccountingClosingFromStore(this.$store);
            if (!lastAccountingClosingDate) {
                return null;
            } else {
                const lastClosingEndDate = lastAccountingClosingDate.lastAccountingClosing.endDate;
                const firstResultDate = this.inDocument.isResultOf.results[0].date;
                if (
                    moment(firstResultDate).format("YYYYMMDD") <=
                    moment(lastClosingEndDate).format("YYYYMMDD")
                ) {
                    return firstResultDate;
                }
            }
        }
        return null;
    }

    get editionMessage() {
        if (!this.inDocument) return null;

        const messageTexts: any = {};
        const inDocIsResultOfAcrKey = this.inDocument?.isResultOf?.auditCheck?.key;

        if (this.orphelinDepreciationAcrId) {
            const firstAcrResultInClosedAP: any = this.firstAcrResultDate_InAccountingClosing;
            if (firstAcrResultInClosedAP) {
                messageTexts.auditCheckResults = {
                    title: "Le document d'origine de cet amortissement automatique n'existe plus : ",
                    messages: [
                        "La première dotation aux amortissements est du " +
                            this.formatDate(firstAcrResultInClosedAP) +
                            ", date comprise dans une situation ou période clôturée",
                        "S'il est encore possible, veuillez ré-ouvrir la période afin de pouvoir supprimer le contrôle",
                    ],
                };
            } else {
                messageTexts.auditCheckResults = {
                    title: "Le document d'origine de cet amortissement automatique n'existe plus : ",
                    messages: [
                        "Procéder à la suppression de toutes les écritures d'amortissements générées par le même document",
                    ],
                };
            }
        } else if (inDocIsResultOfAcrKey) {
            // ** ex: "Dot. amos..." isResultOf Depreciation, but Depreciation's document can be isResultOf CutPrevious
            // ** tests if ACR (this.inDocument?.isResultOf) is connected with document or accountingLine resulting from deeper ACR
            const inDeeperAcr =
                this.inDocument?.isResultOf?.accountingLine?.document?.isResultOf?.auditCheck.key ||
                this.inDocument?.isResultOf?.document?.isResultOf?.auditCheck.key ||
                undefined;

            const originalDocumentStatus =
                this.inDocument?.isResultOf?.accountingLine?.document?.status ||
                this.inDocument?.isResultOf?.document?.status;
            if (originalDocumentStatus === "DELETED") {
                messageTexts.originalDocumentDeleted = {
                    title: "Le document d'origine a été supprimé",
                    messages: [],
                };
                messageTexts.originalDocumentDeleted.messages.push(
                    this.$t("document.auditCheckResults.accountingLines"),
                );
            } else {
                messageTexts.auditCheckResults = {
                    title: "Si vous souhaitez modifier ou supprimer ce document, veuillez d'abord supprimer le contrôle suivant: ",
                    messages: [],
                };
                let acrTitle;
                if (inDeeperAcr) {
                    acrTitle = this.$t("audit." + inDeeperAcr + ".title");
                } else {
                    acrTitle = this.$t("audit." + inDocIsResultOfAcrKey + ".title");
                }
                messageTexts.auditCheckResults.messages.push(acrTitle || "Contrôle non trouvé");
            }
        } else {
            const alsConnectedToACR = this.inDocument?.accountingLines?.filter(
                (al) => al.auditCheckResults?.length,
            );

            if (this.inDocument.auditCheckResults?.length || alsConnectedToACR?.length) {
                messageTexts.auditCheckResults = {
                    title: "Les contrôles suivants, rattachés au document, seront supprimés :",
                    messages: [],
                };
                for (const acr of this.inDocument.auditCheckResults) {
                    const acrTitle = this.$t("audit." + acr.auditCheck.key + ".title");
                    messageTexts.auditCheckResults.messages.push(acrTitle || "Contrôle non trouvé");
                    // messageTexts.push(this.$t("document.auditCheckResults.accountingLines"))
                }

                for (const al of alsConnectedToACR) {
                    for (const acr of al.auditCheckResults) {
                        const acrTitle = this.$t("audit." + acr.auditCheck.key + ".title");
                        messageTexts.auditCheckResults.messages.push(
                            acrTitle || "Contrôle non trouvé",
                        );
                    }
                }
            }

            // is document is linked to auditCheckResults
            if (this.inDocument.isDocumentOfAuditCheckResults?.length) {
                messageTexts.auditCheckResults = {
                    title: "Le document est lié au(x) contrôle(s) suivant(s) :",
                    messages: [],
                };

                const acrKeys = this.inDocument.isDocumentOfAuditCheckResults.map((alacr) => {
                    return alacr.key.split("_")[0] || "";
                });
                // filter unique values arrays
                const uniqueAcrKeys = [...new Set(acrKeys)];

                for (const acrKey of uniqueAcrKeys) {
                    const acrTitle = this.$t("audit." + acrKey + ".title");
                    messageTexts.auditCheckResults.messages.push(acrTitle || "Contrôle non trouvé");
                }
            }
            // if the document is a current account and is linked to a VAT declaration, it cannot be deleted
            /* Attente validation fonctionnelle PO
            if(this.inDocument.type === "CURRENT_ACCOUNT" && !!this.inDocument.vatDeclaration) {
                messageTexts.currentAccount = {
                    title: "Le document est rattaché à une déclaration de TVA. Il ne peux pas être supprimé.",
                    messages: [
                        "Si vous avez besoin de le supprimer, contrepassez avec une OD manuelle.",
                    ],
                };
            }
            */
        }
        let message: string;
        if (!isEmpty(messageTexts)) {
            for (const key in messageTexts) {
                message = `<p class="pt-4"><b>${messageTexts[key].title}</b></p>
                    <p class="pb-2 pl-4"> - ${messageTexts[key].messages.join(
                        "</p><p class='pl-4 pb-2'> - ",
                    )}</p>`;
            }
            return message;
        }
        return null;
    }

    //
    // delete document
    //

    deleteDocumentDialog: boolean = false;
    deleteDocumentLoading: boolean = false;

    deleteOrphelinDocumentDialog: boolean = false;
    deleteOrphelinDocumentLoading: boolean = false;

    get orphelinDepreciationAcrId() {
        if (!this.inDocument) return null;

        if (this.inDocument?.isResultOf?.auditCheck) {
            const inDocIsResultOfAcrKey = this.inDocument?.isResultOf?.auditCheck?.key;
            if (inDocIsResultOfAcrKey && inDocIsResultOfAcrKey === "rIr4hG5NdQWyEnIXvhnYtmmm") {
                // ** fixedAssetsToDepreciate
                const depreciationNotConnectedToAL = !this.inDocument?.isResultOf?.accountingLine;
                if (depreciationNotConnectedToAL) {
                    return this.inDocument?.isResultOf?.id;
                }
            }
        }
        return null;
    }

    get disabledDelete() {
        if (!this.inDocument) return true;

        if (
            this.orphelinDepreciationAcrId?.length &&
            this.firstAcrResultDate_InAccountingClosing?.length
        ) {
            return true;
        }

        return isDeletionDisabled(this.inDocument, this.isAccountingUser, this.$store);
    }

    async deleteAuditCheckResult(acrId) {
        if (acrId?.length) {
            const firstAcrResultDateInAccountingClosing =
                this.firstAcrResultDate_InAccountingClosing;
            // ////////// Eric : or situation ? //////////
            if (!firstAcrResultDateInAccountingClosing?.length) {
                try {
                    const deletedAcr = await this.$apollo.mutate({
                        mutation: DELETE_AUDIT_CHECK_RESULT_AND_RESULTS,
                        variables: {
                            id: acrId,
                        },
                    });

                    if (deletedAcr.data) {
                        this.deleteOrphelinDocumentDialog = false;
                        this.deleteOrphelinDocumentLoading = false;

                        if (this.mode === "toBeDone") {
                            return this.next();
                        }
                        if (this.mode !== "Router") {
                            return this.$emit("deleted");
                        }
                        this.$router.go(-1);
                    }
                } catch (e) {
                    console.error(e);
                }
            }
        }
    }

    async deleteDocument() {
        this.deleteDocumentLoading = true;

        let untiedDocumentFromAcr = false;

        // untied link with an alAcr
        if (this.inDocument.isDocumentOfAuditCheckResults) {
            const auditCheckResultIds = this.inDocument.isDocumentOfAuditCheckResults.map(
                (alacr) => {
                    return { id: alacr.id };
                },
            );

            await this.$apollo.mutate({
                mutation: UPDATE_DOCUMENT_AUDIT_CHECK_RESULTS,
                variables: {
                    documentId: this.inDocument.id,
                    isDocumentOfAuditCheckResults: {
                        disconnect: auditCheckResultIds,
                    },
                },
            });

            untiedDocumentFromAcr = true;
        }

        await this.$apollo.mutate({
            mutation: DELETE_DOCUMENT_QUERY,
            variables: {
                documentId: this.inDocument.id,
            },
        });

        // try {
        //     await this.createUserActivity(this.inDocument.id, "DELETE")
        // } catch(e) {
        //     console.error(e)
        // }
        this.deleteDocumentDialog = false;
        this.deleteDocumentLoading = false;

        // The mode can be "toBeDone" or "ToBeDone" the === is not working
        // if ("toBeDone".localeCompare(this.mode, undefined, { sensitivity: "base" }) === 0) {
        if (this.mode === "toBeDone") {
            this.emitDeletedArc(untiedDocumentFromAcr);
            return this.next();
        }
        // if ("GeneralLedger".localeCompare(this.mode, undefined, { sensitivity: "base" }) === 0) {
        if (this.mode !== "Router") {
            this.emitDeletedArc(untiedDocumentFromAcr);
            return this.$emit("deleted");
        }

        this.$router.go(-1);
    }

    get documentStatus() {
        let status = "";
        if (this.linkedBankTransactions && this.linkedBankTransactions.length) {
            status = this.$t(
                "document.common.linkWithBanktransactions",
                { count: this.linkedBankTransactions.length },
                this.linkedBankTransactions.length,
            );
        } else if (this.inDocument.status !== "VALIDATED") {
            status = this.$t("document.status." + this.inDocument.status).toString();
        } else {
            status = this.reconciliationStatus;
        }
        if (this.documentIsInAccountingClosing) {
            status += " - Exercice clos";
        }
        if (this.inDocument.accountingClosing) {
            status += " - Dans une situation";
        }
        return status;
    }

    get documentStatusIcon() {
        switch (this.inDocument.status) {
            case "VALIDATED":
                return "$fa-check-circle";
        }
        return "$fa-exclamation-triangle";
    }

    get reconciliationStatus() {
        return getReconciliationStatus(this.inDocument, this.selectedCompany, this);
    }

    get disabledCallToAction() {
        return this.mode !== "Router";
    }

    get reconciliationCallToAction() {
        return getReconciliationCallToAction(
            this.inDocument,
            this.selectedCompany,
            this.isAccountingUser,
        );
    }

    accountingDate_ = "";

    get accountingDate() {
        if (this.accountingDate_) {
            return this.accountingDate_;
        }
        if (this.document) {
            return getAccountingDate(this.$store, this.document.date);
        }
        return "";
    }

    set accountingDate(value) {
        this.accountingDate_ = value;
    }

    /**
     * Emit deleted-arc event if doEmit is true
     * @param doEmit
     */
    private emitDeletedArc(doEmit: boolean) {
        if (doEmit) {
            this.$emit("deleted-acr");
        }
    }

    //
    // prev / next / stop
    //

    nextDisabled() {
        if (this.mode === "ToBeDone") {
            // from tobedone
            return !this.nextIdIsset;
        }
        return !this.prevNext?.nextId || this.rootOrigin;
    }

    previousDisabled() {
        if (this.mode === "ToBeDone") {
            // from tobedone
            return !this.previousIdIsset;
        }
        return !this.prevNext?.prevId || this.rootOrigin;
    }

    next() {
        if (this.mode === "ToBeDone") {
            // from tobedone
            this.$emit("next");
        } else {
            // console.log("next id", this.nextDocumentId);
            if (!this.prevNext?.nextId) {
                return;
            }
            // this.validated = false
            this.$router.replace({
                name: "document",
                params: {
                    companyId: this.companyId,
                    id: this.prevNext.nextId,
                },
            });
        }
    }

    previous() {
        if (this.mode === "ToBeDone") {
            // from tobedone
            this.$emit("previous");
        } else {
            // console.log("previous id", this.previousDocumentId);
            if (!this.prevNext?.prevId) {
                debugger; // git-ignore
                return;
            }
            // this.validated = false
            this.$router.replace({
                name: "document",
                params: {
                    companyId: this.companyId,
                    id: this.prevNext.prevId,
                },
            });
        }
    }

    stop() {
        this.toBeDoneStatus = false;
        this.$router.back();
    }

    //
    //
    //

    // previousDocumentId = "";
    // nextDocumentId = "";

    form: { [key: string]: any } = {};

    svgVariants: any = [{}];

    activePolygon: { [key: string]: any } = {};

    clearVariantList() {
        this.svgVariants = [];
    }

    get svgPosition() {
        if (this.activePolygon && this.activePolygon.node) {
            const elem = this.zoomManager.getSvgElement();
            if (elem) {
                const parentPos: any = elem.getBoundingClientRect();
                const pos = this.activePolygon.node.getBoundingClientRect();
                const top = `${(pos.y - parentPos.y).toFixed(0)}px`;
                const left = `${(pos.x - parentPos.x).toFixed(0)}px`;

                return {
                    top,
                    left,
                    position: "absolute",
                    outline: "solid 0.3px gray",
                };
            }
        }
        return {};
    }

    showCorrespondingField({
        variant,
        currentIndex,
        copyIndex,
    }: {
        variant: any;
        currentIndex: number;
        copyIndex: number;
    }) {
        if (!variant || !variant.active) return;
        this.activePolygon = {
            node: this.$refs[`variants-${currentIndex}-${copyIndex}`][0],
            meta: variant,
            fieldNames: variant.fieldNames,
            index: currentIndex,
        };

        const pos = this.activePolygon.node.getBoundingClientRect();
        const elem = this.zoomManager.getSvgElement();
        if (this.associatedFields.show === false)
            this.zoomManager.animateZoom(elem, 200, 30, 2, pos);
        this.updateAssociatedFieldsList();
    }

    updateAssociatedFieldsList() {
        const list = {};
        // console.log(this.activePolygon)
        if (!this.activePolygon) return;
        Object.keys(this.form).forEach((k1) => {
            this.activePolygon.fieldNames.forEach((field) => {
                // console.log(field.name, k1)
                if (field.name === k1) list[k1] = this.form[k1];
            });
        });
        this.associatedFields.fields = list;
    }

    get svgScale() {
        if (this.imageWidth && this.analysis?.pdf?.pages?.length) {
            const firstPage = this.analysis.pdf.pages[0];
            if (firstPage?.width) {
                return this.imageWidth / firstPage.width;
            }
        }
        return 1;
    }

    getPoints(vertices: any) {
        if (vertices && vertices.length) {
            return vertices.reduce(
                (acc: string, el: { x: number; y: number }) =>
                    `${acc} ${el.x * this.svgScale},${el.y * this.svgScale} `,
                "",
            );
        }
        return "";
    }

    //
    // reconciliation
    //

    get activateReconciliation() {
        if (!this.currentUser.profile.configuration.accounting.write) return false;
        if (!this.document) return false;
        if (this.document.type === "EXPENSE_REPORT_DOCUMENT") return false;
        return this.document?.status === "VALIDATED";
    }

    openReconciliation() {
        const params: any = {
            companyId: this.companyId,
            documentId: this.documentId,
        };
        if (this.mode === "Router") {
            if (params.documentId) {
                this.$router.push({
                    // name: edition ? "reconciliation-full/bankTransaction" : "reconciliation-client/bankTransaction",
                    name: "reconciliation/document",
                    params,
                });
            }
        } else {
            this.$emit("openReconciliation", params);
        }
    }

    //
    // zoom
    //
    associatedFields = {
        show: false,
        fields: {},
    };

    get showZoomActions() {
        if (this.isPDF) return false;
        if (this.isCSV) return false;
        return !!this.document.signedUrl;
    }

    /**
     * Determines whether the rotate actions should be displayed.
     *
     * @returns {boolean} `false` if the document is a CSV file; otherwise, `true` if the document has a signed URL.
     */
    get showRotateActions() {
        if (this.isCSV) return false;
        return !!this.document.signedUrl;
    }

    hideVariantList() {
        this.associatedFields.show = false;
    }

    svgSuffix: string = "";
    zoomManager = new ZoomManager();

    //
    // field
    //

    computeSVGVariants(document: any) {
        // console.log("heheheh", document.signedUrl);
        if (document.variants) {
            document.variants.forEach((variant) => {
                const svgVariant = {
                    ...variant,
                    fieldNames: [],
                    active: false,
                    focus: false,
                };
                this.svgVariants.push(svgVariant);
            });
        }
    }

    cleanVariant(meta: any) {
        if (meta.index === null || meta.index === undefined) return;
        if (meta.index >= 0 && meta.index < this.svgVariants.length) {
            const variant = this.svgVariants[meta.index];
            if (variant) {
                variant.focus = false;
                variant.active = false;
            } else {
                debugger; // git-ignore
            }
        }
    }

    highlightField(meta: any, state: boolean) {
        if (meta.index === null || meta.index === undefined) return;
        if (meta.index >= 0 && meta.index < this.svgVariants.length) {
            if (this.svgVariants[meta.index]) {
                if (this.svgVariants[meta.index].focus !== state) {
                    this.svgVariants[meta.index].focus = state;
                    // this.$forceUpdate();
                }
            } else {
                debugger; // git-ignore
            }
        } else {
            debugger; // git-ignore
        }
    }

    validateDateField(meta: any, type: string): boolean {
        // console.log(meta.value)
        if (type === "date" && moment(meta.value, "YYYY-MM-DD").isValid()) {
            meta.validated = true;
            return true;
        }
        meta.validated = false;
        return false;
    }

    getPendingReconciliation() {
        if (!this.document.accountingLines || !this.document.accountingLines.length) {
            return undefined;
        }
        for (const al of this.document.accountingLines) {
            if (
                al.reconciliation &&
                (al.reconciliation.status === "PENDING_VALIDATION_FROM_CLIENT" ||
                    al.reconciliation.status === "PENDING_VALIDATION")
            ) {
                return al.reconciliation;
            }
        }
        return undefined;
    }

    //
    // startToBeDone if necessary
    //
    startToBeDoneIfNecessary() {
        this.$emit("task-ended", {
            documentId: this.documentId,
        });
    }

    //
    // Accountable Account
    //

    subNetAmounts: any = [];

    closeAccountableAccount() {}

    stockOperation = null;

    async selectAccountableAccount(data) {
        let result: any = {};
        if (data && data.accountableAccount && data.itemId) {
            const prevAccountableAccount = this.document.accountableAccount;
            if (
                !prevAccountableAccount ||
                prevAccountableAccount.name !== data.accountableAccount.name
            ) {
                result = await this.$apollo.mutate({
                    mutation: UPDATE_DOCUMENT_ACCOUNTABLE_ACCOUNT,
                    variables: {
                        id: data.itemId,
                        accountableAccount: await getConnectAccountableAccount(
                            this.$store,
                            this.$apollo,
                            data.accountableAccount.name,
                            true,
                            data.accountableAccount.description,
                        ),
                        // accountableAccountName: data.accountableAccount.name,
                        // accountableAccountTableId: this.$store.state.accountableAccountTable?.id
                    },
                });
                this.document.accountableAccount = data.accountableAccount;

                const eligibleDocTypes = ["SALES_INVOICE", "PURCHASE_INVOICE"];

                if (eligibleDocTypes.indexOf(this.document.type)) {
                    const toRemoveAccountableAccountSuggestions = [];
                    const toAddAccountableAccountSuggestions = [];
                    if (!prevAccountableAccount) {
                        toAddAccountableAccountSuggestions.push({
                            documentId: this.document.id,
                            accountableAccountId: data.accountableAccount.id,
                        });
                    } else if (prevAccountableAccount.name !== data.accountableAccount.name) {
                        toRemoveAccountableAccountSuggestions.push({
                            documentId: this.document.id,
                            accountableAccountId: prevAccountableAccount.id,
                        });
                        toAddAccountableAccountSuggestions.push({
                            documentId: this.document.id,
                            accountableAccountId: data.accountableAccount.id,
                        });
                    }
                    if (
                        toAddAccountableAccountSuggestions.length ||
                        toRemoveAccountableAccountSuggestions.length
                    ) {
                        await this.$apollo.mutate({
                            mutation: COMPUTE_SUGGESTIONS_FROM_RECONCILIATON,
                            variables: {
                                toAddAccountableAccountSuggestions:
                                    toAddAccountableAccountSuggestions,
                                toRemoveAccountableAccountSuggestions:
                                    toRemoveAccountableAccountSuggestions,
                            },
                        });
                    }
                }
            }
            if (data.accountableAccount.invoiceProduct) {
                let quantities = [];
                if (data.accountableAccount.invoiceProduct.data?.quantities?.length) {
                    quantities = data.accountableAccount.invoiceProduct.data.quantities.map(
                        (q) => ({ quantityName: q.quantityName, quantity: 0 }),
                    );
                }
                if (this.stockOperation) {
                    this.stockOperation.stockProductId = data.accountableAccount.invoiceProduct.id;
                    this.stockOperation.unitQuantity =
                        data.accountableAccount.invoiceProduct.unitQuantity || 1;
                    this.stockOperation.tagId = data.accountableAccount.invoiceProduct.tag
                        ? data.accountableAccount.invoiceProduct.tag.id
                        : undefined;
                    this.stockOperation.data = data.stockOperation.data?.quantities?.length
                        ? data.stockOperation.data.quantities
                        : { quantities: quantities };
                } else {
                    this.stockOperation = {
                        stockProductId: data.accountableAccount.invoiceProduct.id,
                        unitQuantity: data.accountableAccount.invoiceProduct.unitQuantity || 1,
                        productQuantity: 0,
                        tagId: data.accountableAccount.invoiceProduct.tag
                            ? data.accountableAccount.invoiceProduct.tag.id
                            : undefined,
                        data: { quantities: quantities },
                    };
                }
            } else {
                this.stockOperation = null;
            }
            // if (result) {
            //     try {
            //         await this.createUserActivity(this.document.id,"UPDATE")
            //     } catch(e) {
            //         console.error(e)
            //     }
            // }
        }
    }

    _closeMultiAccountableAccountWindow() {
        this.loadSubNetAmounts(this.inDocument);
    }

    async _onSubAccountableAccountModified() {
        if (this.subNetAmounts.length === 1) {
            await this.selectAccountableAccount({
                accountableAccount: this.subNetAmounts[0].accountableAccount,
                itemId: this.documentId,
            });
        }

        let data = null;
        if (this.inDocument.data) {
            data = JSON.parse(JSON.stringify(this.inDocument.data));
        }
        data = this.streamSubNetAmonts(data);

        if (data) {
            const keys = Object.keys(data);
            if (!keys.length) {
                data = null;
            }
        }
        await this.$apollo.mutate({
            mutation: UPDATE_DOCUMENT_DATA,
            variables: {
                documentId: this.documentId,
                data: data,
            },
        });
        /*try {
            await this.createUserActivity(this.document.id,"UPDATE")
        } catch(e) {
            console.error(e)
        }*/
    }

    loadSubNetAmounts(document) {
        return;
        if (!this.subNetAmounts.length) {
            if (document.data && document.data.subNetAmounts) {
                this.subNetAmounts = document.data.subNetAmounts.map((sna) => ({
                    accountableAccount: {
                        name: sna.accountableAccountName
                            ? sna.accountableAccountName.name
                                ? sna.accountableAccountName.name
                                : sna.accountableAccountName
                            : sna.accountableAccount.name,
                    },
                    netAmountSigned: sna.netAmountSigned,
                }));
            } else {
                this.subNetAmounts = [];
                // document.data = { ...document.data, subNetAmounts: [] }
                if (document && document.accountableAccount) {
                    this.subNetAmounts.push({
                        accountableAccount: document.accountableAccount,
                        netAmountSigned: this.netAmountSigned,
                    });
                } else if (document && document.accountableAccountAuto) {
                    this.subNetAmounts.push({
                        accountableAccount: document.accountableAccountAuto,
                        netAmountSigned: this.netAmountSigned,
                    });
                }
            }
        }
    }

    streamSubNetAmonts(inData) {
        let data = inData;
        if (this.subNetAmounts && this.subNetAmounts.length > 1) {
            if (!data) {
                data = {};
            }
            if (this.document.type === "SALES_INVOICE") {
                data.subNetAmounts = this.subNetAmounts.map((sna, index) => ({
                    accountableAccountName: sna.accountableAccount.name,
                    netAmountSigned:
                        this.form.multi_prices["prices_" + (index + 1)]["netAmount_" + (index + 1)]
                            .value,
                }));
                data.subNetAmounts = data.subNetAmounts.filter(
                    (x) => x.accountableAccountName && x.netAmountSigned,
                );
            } else {
                data.subNetAmounts = this.subNetAmounts.map((sna) => ({
                    accountableAccountName: sna.accountableAccount.name,
                    netAmountSigned: sna.netAmountSigned,
                }));
            }
        } else if (data && data.subNetAmounts) {
            delete data.subNetAmounts;
        }
        return data;
    }

    //
    // CHAT
    //
    open_chat: boolean = false;

    // inShowMessage = false;

    wishStatus: string = "";

    getChatSubTitle() {
        if (this.wishStatus === "INFORMATION_REQUEST") {
            return "Demande d'information";
        }
        if (this.wishStatus === "DENIED") {
            return "Rejeter";
        }
        return "Réponse";
    }

    setOpenChat(reason) {
        if (!this.open_chat) {
            this.open_chat = true;
        }
        // this.inShowMessage = true;
        this.wishStatus = reason;
        // setTimeout(() => { this.inShowMessage = false }, 100);
    }

    get openChat() {
        if (!this.currentUser.profile.configuration.chat.read) return false;
        if (this.document.chat) {
            return true;
        }
        return this.open_chat;
    }

    onShowMessageChanged(data) {
        this.open_chat = data;
        this.wishStatus = "";
    }

    async onMessageSent(data) {
        if (!this.inDocument?.id) {
            debugger; // git-ignore
            return;
        }
        let update = false;
        const variables: any = {
            id: this.inDocument.id,
            chat: undefined,
        };
        if (this.wishStatus) {
            variables.status = this.wishStatus;
            update = true;
            this.wishStatus = "";
        }
        if (!this.inDocument.chat) {
            variables.chat = { connect: { id: data.chatId } };
            this.inDocument.chat = {
                id: data.chatId,
                type: "OBJECT",
                company: null,
                lastMessage: null,
                bankTransaction: null,
                document: null,
                expenseReport: null,
            };
            update = true;
        } else if (this.inDocument.chat.id !== data.chatId) {
            // debugger;
        }

        if (update) {
            await this.$apollo.mutate({
                mutation: UPDATE_DOCUMENT_CHAT,
                variables: variables,
            });
            if (variables.status === "DENIED") {
                this.startToBeDoneIfNecessary();
            }
        }
        if (variables.status) {
            this.inDocument.status = variables.status;
        }
    }

    //
    //
    //

    dueDate: string = "";

    get dueDateEnable() {
        if (
            this.document &&
            (this.document.type === "SALES_INVOICE" || this.document.type === "PURCHASE_INVOICE")
        )
            return true;
        return false;
    }

    async onDueDateChanged(date) {
        if (this.document && this.document.id) {
            this.dueDate = date;
            if (moment(this.dueDate).isValid()) {
                await this.$apollo.mutate({
                    mutation: UPDATE_DOCUMENT_DUEDATE,
                    variables: {
                        id: this.document.id,
                        dueDate: getDBFormattedDate(this.dueDate),
                    },
                });

                if (this.dueDate.length === 10) {
                    try {
                        await this.createUserActivity(this.document.id, "UPDATE");
                    } catch (e) {
                        console.error(e);
                    }
                }
            }
        }
    }

    get thirdPartyName() {
        if (this.document.type === "PURCHASE_INVOICE" || this.document.type === "SALES_INVOICE") {
            return this.document.thirdPartyCompany
                ? this.document.thirdPartyCompany.name || ""
                : "";
        }
        if (this.document.type == "EXPENSE_REPORT" || this.document.type === "PAY_SLIP") {
            return getUserDisplayName(this.inDocument.owner);
        }

        return "";
    }

    get invoiceNumberTitle() {
        if (this.document.type === "PURCHASE_INVOICE" || this.document.type === "SALES_INVOICE") {
            return "N° de Facture";
        }
        return "N° de pièce";
    }

    get showDetail() {
        if (this.document && this.document.id) {
            if (this.document.type === "EXPENSE_REPORT_DOCUMENT") {
                return false;
            }
            if (
                this.document.status.startsWith("ANALYSED") ||
                this.document.status === "VALIDATED"
            ) {
                return true;
            }
        }
        return false;
    }

    ocr = null;
    showOCR: boolean = false;
    ocrLoading: boolean = false;

    async onOCRChanged() {
        this.showOCR = !this.showOCR;
        debugger;
        if (this.showOCR && !this.ocr && this.document.signedUrlOCR) {
            this.ocrLoading = true;
            const result = await axios.get(this.document.signedUrlOCR as string, {});
            if (result && result.data && result.data.sentences) {
                for (const sentence of result.data.sentences) {
                    if (sentence.tokens) {
                        for (const token of sentence.tokens) {
                            token.high = false;
                            token.selected = false;
                        }
                    }
                }
                this.ocr = result.data;
            } else {
                this.ocr = {};
            }
            this.ocrLoading = false;
        }
        if (this.document.signedUrl && !this.isPDF) {
            this.zoomManager.instanciateSvgZoom(this.svgSuffix);
        }
    }

    analysis_ = null;

    async getAnalysis() {
        if (!this.analysis_ && this.inDocument?.signedUrlAnalysis) {
            // console.log("getAnalysis", this.inDocument.signedUrlAnalysis);
            const result = await axios.get(this.inDocument.signedUrlAnalysis as string, {});
            if (result && result.data) {
                this.analysis_ = result.data;
            } else {
                this.analysis_ = {};
            }
        }
    }

    get analysis() {
        if (this.analysis_) {
            return this.analysis_;
        }
        return this.inDocument?.analysis;
    }

    selectedText = "";

    onClickToken(token) {
        token.selected = !token.selected;
        let text = "";
        for (const sentence of this.ocr.sentences) {
            for (const token of sentence.tokens) {
                if (token.selected) {
                    if (text) text += " ";
                    text += token.word;
                }
            }
        }
        this.selectedText = text;
        setTimeout(() => {
            const copyText = document.getElementById("selectedText") as any;
            copyText.select();
            copyText.setSelectionRange(0, 99999);
            document.execCommand("copy");
        }, 0);
        // alert("Copied the text: " + copyText.value);
    }

    emptySelectedText() {
        for (const sentence of this.ocr.sentences) {
            for (const token of sentence.tokens) {
                token.selected = "";
            }
        }
        this.selectedText = "";
    }

    onFieldAssociation(selectedField: any, propertyName: string) {}

    lastDocumentValidationDone = false;
}
